import React, { createContext, useState, useContext } from 'react';

// Dictionary / Kamus Bahasa
const translations = {
    en: {
        "welcome_title": "Welcome to MPStore Training Center",
        "typing_1": "Learn MPStore features easily",
        "typing_2": "Complete tutorials to grow your business",
        "typing_3": "Manage business more efficiently!",
        "search_placeholder": "Search tutorials, tips, or ask anything...",
        "search_button": "Search",
        "searching": "Searching...",
        "search_result": "Search results for",
        "back_home": "Back to Home",
        "ai_answer": "AI Answer",
        "analyzing": "Analyzing...",
        "no_ai_response": "No AI response available.",
        "popular_categories": "Popular Categories",
        "tab_video": "Video",
        "tab_book": "Tutorial Book",
        "tab_content": "Content",
        "trending": "Trending",
        "resources": "MPStore Resources",
        "download_app": "Download App",
        "news_updates": "News & Updates",
        "no_content": "No content available for this category.",
        "view_on_tiktok": "View on TikTok",
        "view_full": "View Full",
        "download": "Download",
        "read_click": "Click to read",
        "language": "Language"
    },
    id: {
        "welcome_title": "Selamat Datang di MPStore Training Center",
        "typing_1": "Belajar fitur-fitur MPStore dengan mudah",
        "typing_2": "Tutorial lengkap untuk kembangkan bisnismu",
        "typing_3": "Kelola usaha jadi lebih efisien!",
        "search_placeholder": "Cari tutorial, tips, atau tanyakan apapun...",
        "search_button": "Cari",
        "searching": "...",
        "search_result": "Hasil pencarian",
        "back_home": "Kembali ke Beranda",
        "ai_answer": "Jawaban AI",
        "analyzing": "Sedang menganalisis...",
        "no_ai_response": "Tidak ada respons AI yang tersedia.",
        "popular_categories": "Kategori Populer",
        "tab_video": "Video",
        "tab_book": "Buku Tutorial",
        "tab_content": "Konten",
        "trending": "Trending",
        "resources": "MPStore Resources",
        "download_app": "Download App",
        "news_updates": "News & Updates",
        "no_content": "Belum ada konten untuk kategori ini.",
        "view_on_tiktok": "Lihat di TikTok",
        "view_full": "Buka Full",
        "download": "Download",
        "read_click": "Klik untuk membaca",
        "language": "Bahasa"
    }
};

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
    const [language, setLanguage] = useState('id'); // Default bahasa Indonesia

    const t = (key) => {
        return translations[language][key] || key;
    };

    const changeLanguage = (lang) => {
        setLanguage(lang);
    };

    return (
        <LanguageContext.Provider value={{ language, changeLanguage, t }}>
            {children}
        </LanguageContext.Provider>
    );
};

export const useLanguage = () => useContext(LanguageContext);